import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(rootSaga);

import { all } from 'redux-saga/effects';
import termsAndConditionsSaga from './termsAndConditions';
import progressiveJackpotsSaga from './progressiveJackpots';
import propertiesSaga from './properties';
export default function rootSaga() {
  return _regeneratorRuntime.wrap(function rootSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return all([termsAndConditionsSaga(), progressiveJackpotsSaga(), propertiesSaga()]);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}